/* eslint-disable @typescript-eslint/ban-ts-comment */
import type { QuestionIndexing } from "@kunduz/data-access-qi-api";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export function useQISimilarQuestions(
  courseSlug: string,
  iso?: string
): {
  similarQuestions: QuestionIndexing.TrQiQuestion[];
  similarQuestionsLoading: boolean;
  similarQuestionsError: any;
} {
  const shouldFetch = !!courseSlug && !!iso;

  const { data, error, isLoading, isRefetching } = useQuery({
    queryKey: ["QISimilarQuestions", [courseSlug, iso]],
    queryFn: () =>
      fetchSimilarQuestions(courseSlug, {
        lang: iso,
      }),
    enabled: shouldFetch,
  });

  return {
    similarQuestions: data,
    similarQuestionsLoading: isLoading || isRefetching,
    similarQuestionsError: error,
  };
}

function fetchSimilarQuestions(courseSlug: string, params: any) {
  return axios
    .get(`/api/questions/similar/${courseSlug}/`, {
      params,
    })
    .then((response) => response.data);
}
